import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import CryptoJS from "crypto-js";
import {
  getNotificationAPI,
  markAsReadNotificationAPI,
} from "../../api/apis/notification";
import NotificationCard from "../../containers/notificationList";
import {
  Box,
  Button,
  HStack,
  Pressable,
  Text,
  VStack,
  useMediaQuery,
  Spinner,
} from "native-base";
import MobileHeader from "../../layout/header/mobileHeader";
import WebHeader from "../../layout/header/webHeader";
import Breadcrumbs from "../../components/breadcrumb";
import { COLORS } from "../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { Toaster } from "../../components/toaster";
import ContainerCards from "../../components/cards";
import { lastVisitedPage } from "../../store/reducers/userSlice";
import { LoaderAnimation } from "../../components/spinner";
import CustomButton from "../../components/button";
import {
  activeEventTab,
  setNotification,
} from "../../store/reducers/eventSlice";
import { eventDetailsAPI } from "../../api/apis/event";
import config from "../../utils/config";

const NotificationPage = () => {
  const toaster = Toaster();
  const dispatch = useDispatch();
  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const notify = useSelector((state) => {
    return state.event.notification;
  });
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectTo, setRedirectTo] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState([]);
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: { name: "Notifications", path: "/notification" },
    activeActivePage: { name: "", path: "" },
  };
  const [unreadCount, setUnreadCound] = useState(0);
  const [firstTime, setFirstTime] = useState(true);

  useEffect(() => {
    dispatch(lastVisitedPage("/notification"));
    sessionStorage.setItem("isFirstVisit", "false");
    getNotification();
  }, []);

  if (shouldRedirect) {
    return <Redirect to={redirectTo} />;
  }

  const getFormattedDate = (dates) => {
    const reformattedDateString = dates.replace(
      /(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})/,
      "$3-$2-$1T$4"
    );
    const originalDate = new Date(reformattedDateString);
    originalDate.setHours(originalDate.getHours() + 5);
    originalDate.setMinutes(originalDate.getMinutes() + 30);
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      // timeZone: "UTC"
    }).format(originalDate);

    return formattedDate;
  };

  async function getNotification(pages = page, add = false, per_page = 10) {
    setIsLoading(true);
    let notifiy = await getNotificationAPI(pages, per_page);
    if (notifiy?.data?.data?.data) {
      let notify = [];
      Object.keys(notifiy.data.data.data).length > 0 &&
        notifiy.data.data.data["notifications data"].map((item) => {
          notify.push({
            id: item._id,
            event_id: item.event_id,
            image: item.image,
            video: item.video,
            description: item.description,
            datetime: getFormattedDate(item.datetime),
            status: item.read,
            type: item.notification_type,
            package_id: item.package_id,
            mis: item?.mis,
          });
        });
      setPagination(notifiy?.data?.data?.pagination?.pages);
      if (add) {
        setNotificationData(notify);
      } else if (!add)
        setNotificationData((prevItems) => [...prevItems, ...notify]);
      setPage(notifiy?.data?.data?.pagination?.page + 1);
      setUnreadCound(notifiy?.data?.data?.data.unread_count);
    }
    setIsLoading(false);
    setFirstTime(false);
  }

  const handleMarkAsReadNotification = async (
    id,
    status,
    event_id,
    package_id,
    type,
    mis
  ) => {
    LoaderAnimation.show();
    let allNotification = { notification_ids: [] };
    if (typeof id === "string" && !status) {
      allNotification["notification_ids"].push({
        notification_id: id,
      });
    }
    if (allNotification["notification_ids"].length > 0) {
      let res = await markAsReadNotificationAPI(allNotification);
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        await getNotification(1, true, notificationData.length);
      }
    } else {
      let res = await markAsReadNotificationAPI();
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        await getNotification(1, true, notificationData.length);
      }
    }
    if (event_id) {
      if (type !== "expense") {
        let res = await eventDetailsAPI(event_id);
        if (res.error) {
          toaster(res.message, "error", "error");
          LoaderAnimation.hide();
          return;
        } else {
          sessionStorage.setItem(
            "event",
            CryptoJS.AES.encrypt(
              JSON.stringify(res?.data?.data?.data),
              config.eventKey
            ).toString()
          );
        }
      }
      if (type === "expense") {
        if (mis && mis === "event") {
          dispatch(activeEventTab("event"));
        } else {
          dispatch(activeEventTab("mice"));
        }
        setRedirectTo("/dashboard");
        setShouldRedirect(true);
      } else {
        setRedirectTo("/event-detail");
        setShouldRedirect(true);
      }
    } else if (package_id) {
      if (type === "package_approved") sessionStorage.setItem("package", type);
      dispatch(activeEventTab("packages"));
      setRedirectTo("/home");
      setShouldRedirect(true);
    } else if (allNotification["notification_ids"].length > 0) {
      setRedirectTo("/home");
      setShouldRedirect(true);
    }
    dispatch(setNotification(!notify));
    LoaderAnimation.hide();
  };

  const handleMarkAsReadNotifications = async (
    id,
    status,
    event_id,
    package_id,
    type,
    mis
  ) => {
    if (type === "expense") {
      if (mis && mis === "event") {
        dispatch(activeEventTab("event"));
      } else {
        dispatch(activeEventTab("mice"));
      }
      setRedirectTo("/dashboard");
      setShouldRedirect(true);
    }
    if (event_id && type !== "expense") {
      let res = await eventDetailsAPI(event_id);
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        sessionStorage.setItem(
          "event",
          CryptoJS.AES.encrypt(
            JSON.stringify(res?.data?.data?.data),
            config.eventKey
          ).toString()
        );
      }
      setRedirectTo("/event-detail");
      setShouldRedirect(true);
    } else if (package_id) {
      if (type === "package_approved") sessionStorage.setItem("package", type);
      setRedirectTo("/home");
      setShouldRedirect(true);
      dispatch(activeEventTab("packages"));
    } else if (type !== "expense") {
      setRedirectTo("/home");
      setShouldRedirect(true);
    }
  };

  return (
    <Box minH={"100vh"} background={COLORS.THEME_BACKGROUND}>
      <Box bg={COLORS.WHITE_COLOR}>
        {MobileWindow ? (
          <MobileHeader showTabs={false} />
        ) : (
          <>
            <WebHeader showTabs={false} />
            <Box p={4} px={"5rem"}>
              <Breadcrumbs path={breadcrumbDetails} />
            </Box>
          </>
        )}
      </Box>
      <Box mx={MobileWindow ? 5 : 20} my={5} width={"auto"}>
        {isLoading && firstTime ? (
          <>
            <Text
              fontSize={
                MobileWindow ? "22px" : COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE
              }
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              mb={2}
            >
              Notifications
            </Text>
            <Spinner mt={10} color={COLORS.THEME_COLOR} size="lg" />
          </>
        ) : (
          <>
            <HStack
              justifyContent={"space-between"}
              mb={5}
              alignItems={"center"}
            >
              <Text
                fontSize={
                  MobileWindow ? "22px" : COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE
                }
                fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                mb={2}
              >
                Notifications
              </Text>
              {notificationData.length > 0 && unreadCount > 0 && (
                <Button variant={"none"} onPress={handleMarkAsReadNotification}>
                  <Text
                    width="fit-content"
                    bgColor="none"
                    color={COLORS.THEME_COLOR}
                    fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                    fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  >
                    Mark all as read
                  </Text>
                </Button>
              )}
            </HStack>
            {notificationData.length > 0 && (
              <VStack width={"100%"} space={4}>
                {notificationData.map((item, index) => (
                  // <Pressable
                  //   key={index}
                  //   onPress={() => {
                  //     if (!item.status)
                  //       handleMarkAsReadNotification(item.id, item.status);
                  //   }}
                  // >
                  <ContainerCards
                    background={COLORS.WHITE_COLOR}
                    boxShadow="0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)"
                    height={"auto"}
                    width="100%"
                    padding={"20px"}
                  >
                    <NotificationCard
                      header={!item.status ? item.description : ""}
                      body={item.status ? item.description : ""}
                      timeline={item.datetime}
                      item={item}
                      mt={0}
                      handleMarkAsReadNotification={
                        handleMarkAsReadNotification
                      }
                      handleMarkAsReadNotifications={
                        handleMarkAsReadNotifications
                      }
                    />
                  </ContainerCards>
                  // </Pressable>
                ))}
              </VStack>
            )}
          </>
        )}
      </Box>

      <Box my={4} alignItems="center" justifyContent="center">
        {notificationData &&
          notificationData.length > 0 &&
          !isNaN(pagination) &&
          pagination >= page && (
            <CustomButton
              text="Load More"
              onPress={() => {
                getNotification(page, false, 10);
              }}
            />
          )}
      </Box>
    </Box>
  );
};

export default NotificationPage;
